class FeaturedProductsSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.featuredProductsSlider');
    this.prevBtn = this.querySelector('.featuredProducts__nav--prev');
    this.nextBtn = this.querySelector('.featuredProducts__nav--next');
  }

  connectedCallback() {
    if (!this.slider || typeof Swiper === 'undefined') return;

    if (this.slider.dataset.fpInit === '1') return;
    this.slider.dataset.fpInit = '1';

    this.init();
  }

  disconnectedCallback() {
    if (this.swiper && typeof this.swiper.destroy === 'function') {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  init() {
    const config = this.getConfig();

    this.swiper = new Swiper(this.slider, {
      slidesPerView: config.perMobile,
      spaceBetween: config.gapMobile,
      watchOverflow: true,
      navigation: {
        nextEl: this.nextBtn,
        prevEl: this.prevBtn,
        disabledClass: 'swiper-button-disabled',
      },
      breakpoints: {
        576:  { slidesPerView: config.perMobile,       spaceBetween: config.gapMobile  },
        768:  { slidesPerView: config.perTablet,       spaceBetween: config.gapDesktop },
        992:  { slidesPerView: config.perBigTablet,    spaceBetween: config.gapDesktop },
        1200: { slidesPerView: config.perSmallDesktop, spaceBetween: config.gapDesktop },
        1500: { slidesPerView: config.perDesktop,      spaceBetween: config.gapDesktop },
      },
    });
  }

  getConfig() {
    const data = this.slider.dataset;
    const perDesktop = parseFloat(data.perDesktop) || 5;

    return {
      perDesktop,
      perSmallDesktop: parseFloat(data.perSmallDesktop) || perDesktop,
      perBigTablet:    parseFloat(data.perBigTablet)    || 3,
      perTablet:       parseFloat(data.perTablet)       || 2,
      perMobile:       parseFloat(data.perMobile)       || 1.2,
      gapDesktop:      parseInt(data.gapDesktop, 10)    || 24,
      gapMobile:       parseInt(data.gapMobile, 10)     || 16,
    };
  }
}

if (!customElements.get('featured-products-slider')) {
  customElements.define('featured-products-slider', FeaturedProductsSlider);
}
